module.exports = __webpack_public_path__ + "static/media/ad.1b20e169.png";